// extracted by mini-css-extract-plugin
module.exports = {"page-title":"PageTitle_page-title__31Td8"};